/**
 * Normalizes `gatorprotect_hosting_id` from /gator-protect listing for upgrade API.
 * Empty / missing values mean the client has no Protect product yet (use fastcheckout).
 */
export function parseGatorProtectUpgradeHostingId(raw) {
  if (raw == null) {
    return undefined;
  }
  const str = String(raw).trim();
  if (str === '') {
    return undefined;
  }
  const n = Number(str);
  if (!Number.isFinite(n) || n <= 0) {
    return undefined;
  }
  return n;
}
